import { createStore } from "vuex";
import axios from 'axios';

export default createStore({
    state: {
        refreshData: [],
        ag_edit: [],
        wl_edit: [],
        op_edit: [],
        change: {
            'change': 0, 
            'item': []
        },  // 0 - No change, 1 - added , 2 updated
        white_lable_change: {
            'change': 0, 
            'item': []
        },
        agent_change: {
            'change': 0, 
            'item': []
        },
        loggedIn: false,
        authData: {
            'name': '',
            'userid': '',
            'role':'',
            'status':0,
        },
        authStatus: 0,
        isLoader: false,
        item_data:{},
        origin_path: window.location.origin + "/",
        ticket_status: {
            0: {
                text: 'Open',
                theme: 'open-thm'
            },
            1: {
                text: 'Close',
                theme: 'close-thm'
            },
            2: {
                text: 'Pending',
                theme: 'pending-thm'
            },
        },
        chat_request: null,
        action_chat: null,
        open_chat_count: null,
        onlineAgents: [],
        agentsIds:[],
        permissionList: null,
        socialMediaLinks: null
    },
    getters: {
        onlineAgents: state => state.onlineAgents,
        permissionList: state => state.permissionList,
        socialMediaLinks: state => state.socialMediaLinks
    },
    mutations: {
        setAuthUserStatus(state, payload) {
            state.authStatus = payload
            if(state.authData) {
                state.authData.status = payload
            }
        },
        setAuthUser(state, payload){
            if (payload == null) {
                state.loggedIn = 0;
            } else {
                state.loggedIn = 1;
            }
            state.authData = payload
        },
        setUserProfile(state, payload) {
            if(state.authData) state.authData.profile_picture = payload;
        },
        is_loader(state, payload) {
            state.isLoader = payload
        },
        ag_data_Edit(state, payload) {
            state.ag_edit = payload
        },
        wl_data_Edit(state, payload) {
            state.wl_edit = payload
        },
        op_data_Edit(state, payload) {
            state.op_edit = payload
        },
        refresh_List(state, payload) {
            const context = payload.data.context || 'default';
            if (context === 'agentSession') {
                const perPage = payload.data.per_page || 100;
                const page = payload.data.current_page || 1;
                let url = `/agents/agent-sessions/${payload.data.agentId}?page=${page}&per_page=${perPage}`;
                axios.get(url).then(res => {   
                    state.agentSessionHistory = res.data.data.items;
                });
            }
            else{
                state.refreshData = payload;
            }
        },
        ticket_List(state, payload) {
            state.data = payload
        },
        singledata(state, payload) {
            state.item_data = payload
        },
        data_Updated(state, payload) {
            state.change = payload
        },
        white_lable_data_Updated(state, payload) {
            state.white_lable_change = payload
        },
        agent_data_Updated(state, payload) {
            state.agent_change = payload
        },
        push_received_chat_request(state, payload) {
            state.chat_request = payload
        },
        action_at_chat(state, payload) {
            state.action_chat = payload
        },
        open_chat_count(state, payload) {
            state.open_chat = payload
        },
        setOnlineAgents(state, agents) {
            state.onlineAgents = agents;
        },
        addOrUpdateAgent(state, agent) {
            const existing = state.onlineAgents.find(a => a.userid === agent.userid);
            if (existing) {
                existing.lastSeen = Date.now();
            } else {
                state.onlineAgents.push({ ...agent, lastSeen: Date.now() });
            }
            window.dispatchEvent(new CustomEvent("agents-updated", { detail: state.onlineAgents }));
        },
        removeAgent(state, userid) {
            state.onlineAgents = state.onlineAgents.filter(a => a.userid !== userid);
            window.dispatchEvent(new CustomEvent("agents-updated", { detail: state.onlineAgents }));
        },
        setAgentsIds(state, agents) {
            state.agentsIds = agents;
        },
        SetPermissionList(state, permissionList){
            state.permissionList = permissionList
        },
        setSocialMediaLinks(state, links){
            state.socialMediaLinks = links
        }
    },
    actions: {
    }
});
